import axiosInstance from "../../config/axiosInstance";

const signinRequest = async ({ email, password }) => {
  return await axiosInstance
    .dillApi()
    .post("/security/signin", { email, password });
};

export default signinRequest;
